import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { MAX_FILESIZE_ALLOWED } from 'constants/defaultConstants';

type FileSizeViewProps = {
  file?: File;
};

const FileSizeView: FC<FileSizeViewProps> = ({ file }) => {
  const { t } = useTranslate();

  return (
    <>
      <div className="sub-text mt-1">
        {t('MaxSizeAllowed')} = <code>{MAX_FILESIZE_ALLOWED.text}</code>
        {' | '}
        {t('ActualFileSize')} ={' '}
        <code>{(file && (file.size / 1024 / 1024).toFixed(2)) || 0}mb</code>
      </div>

      {file && file.size > MAX_FILESIZE_ALLOWED.value && (
        <div className="alert alert-icon alert-danger mt-2" role="alert">
          <em className="icon ni ni-alert-circle" />
          <strong>{t('InvalidFile')}</strong>.{' '}
          {t('ExceedsMaximumSizePermitted')}.
        </div>
      )}
    </>
  );
};

export default FileSizeView;
